// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LrLh","col":"styles_col__1r6v1"};